import { render } from "./ComingSoon.vue?vue&type=template&id=fc6f4630&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=fc6f4630&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6f4630"]])

export default __exports__